import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthenticationStatus } from '../enums/enums';
import { NgForm } from '../../../../node_modules/@angular/forms';
import { InvisibleReCaptchaComponent } from '../../../../node_modules/ngx-captcha';

@Component({
  selector: 'app-auth-change-password',
  templateUrl: './auth-change-password.component.html',
  styleUrls: ['./auth-change-password.component.css']
})
export class AuthChangePasswordComponent extends AuthBaseComponent implements OnInit {

  public showCaptcha: boolean = false;
  public _countTimes: number = 0;
  private _form: NgForm;
  private _captchaResponse: string = null;
  private _captchaReady: boolean = false;

  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;

  ngOnInit(): void {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2109' })
      .subscribe(res => console.log("sent elasticLog code:2109 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    sessionStorage.setItem("currentWindow", "עדכן את הסיסמה שלך");
    sessionStorage.setItem("elasticCode", "2189");
  }

  captchaSuccess(captchaResponse: string): void {
    this._captchaResponse = captchaResponse;
    this.callServer();
  }
  captchaReady() {
    this._captchaReady = true;
  }
  submit(form): void {
    this._form = form;
    debugger
    const controls = this.inputsQuery.map(elm => elm);
    let element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element && controls.length > 2) {
      if (controls[1].ngControl.errors.pattern) {
        element = controls[1].elementRef.nativeElement;
      } else if (controls[1].ngControl.errors.required == null) {
        element = controls[2].elementRef.nativeElement;
      }
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid) {
      this.pending = true;
      this.serverError = null;
      if (this._captchaReady) {
        this.captchaElem.execute();
      }
      else {
        this.callServer();
      }
    }
    this.buildFormAccessibility();
  }

  private callServer() {
    this.authUserService.sendAuthData("ChangePassword", { Password: this._form.value.pwOld, NewPassword: this._form.value.pwNew, captchaResponse: this._captchaResponse })
      .subscribe((res: AuthenticationResult) => {
        if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidPassword") {
          this.serverError = "יש להקליד סיסמא המכילה 7-15 אותיות לועזיות קטנות, גדולות, מספרים. על הסיסמא להכיל לפחות תו אחד מכל סוג, ולא הייתה בשימוש ב-10 הסיסמאות הקודמות שלך.";
          if (this.captchaElem != null && this.showCaptcha) {
            this.captchaElem.resetCaptcha();
          }
          if (this._countTimes == 8) {
            this.showCaptcha = true;
          }
          else {
            this._countTimes++;
          }
          const elements = this.inputsQuery.map(elm => elm.elementRef.nativeElement);
          if (elements && elements.length > 0) {
            elements[0].setAttribute('aria-invalid', true);
            setTimeout(() => elements[0].focus(), 0);
          }
        }
        else if (res.Details.UserInputError == "ReCaptchaInvalid") {
          this.captchaElem.resetCaptcha();
          this.serverError = "הקאפצ'ה נכשלה";
        }
        else {
          this.modalService.close(res.Details);
        }
      }, () => this.pending = false,
        () => this.pending = false
      )
  }
}
